import { render, staticRenderFns } from "./referenceSlider.vue?vue&type=template&id=7b6faa7b&"
import script from "./referenceSlider.vue?vue&type=script&lang=ts&"
export * from "./referenceSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports